import styled from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

const TimelineBody = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx(Container, {
    className: className,
    ...rest,
    children: children
  });
};
const Container = styled.div`
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.gray[1];
}};
  font-family: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.InterRegular;
}};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
`;
TimelineBody.defaultProps = {
  className: '',
  children: null
};
TimelineBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { TimelineBody };
//# sourceMappingURL=TimelineBody.js.map
